// apps/web/src/layouts/components/SidebarApprovalQueueBadge.tsx
//
// Badge de cadastros novos aguardando início da aprovação. O número vem de
// `useSidebarBadgeCounts()`, montado uma vez no topo da sidebar admin.

import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

export interface SidebarApprovalQueueBadgeProps {
  count: number;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarApprovalQueueBadge({ count, variant }: SidebarApprovalQueueBadgeProps) {
  const { t } = useTranslation('admin');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-approval-queue-badge"
      label={t('sidebar.badges.approval_pending', { count })}
    />
  );
}
